import cx from "clsx";
import React, { ReactNode } from "react";
import { Button } from "react-bootstrap";
import styles from "./Button.module.scss";

type Props = {
  className?: string;
  onClick?: VoidFunction;
  children?: ReactNode;
  disabled?: boolean;
  [key: string]: any;
};
const NextButton: React.FC<Props> = ({
  className,
  onClick,
  children,
  disabled = false,
  ...otherProps
}) => {
  return (
    <Button
      onClick={onClick}
      variant="primary"
      className={cx(styles.nextButton, className)}
      disabled={disabled}
      {...otherProps}
    >
      {children}
    </Button>
  );
};
export default NextButton;
